"use client";

import { TCtaSection } from "@shared/types";
import { ButtonLink } from "@shared/ui";
import Image from "next/image";

export function CtaSection({ title, description, illustration, background, button }: TCtaSection) {
  return (
    <div
      className="relative text-white overflow-hidden"
      style={{
        background: "linear-gradient(266.05deg, #134E67 3.23%, #1DB0DE 79.09%)",
      }}
    >
      {background && (
        <Image
          src={background?.data?.attributes?.url || ""}
          alt={background?.data?.attributes?.alternativeText || background?.data?.attributes?.name || "CTA Background"}
          width={background?.data?.attributes?.width || 1000}
          height={background?.data?.attributes?.height || 1000}
          className="h-[40%] sm:h-[70%] md:h-auto xl:h-[110%] w-full lg:w-[65%] xl:w-[70%] max-w-[1000px] object-cover bottom-0 right-0 absolute z-1 object-right md:object-left-top lg:object-left"
        />
      )}
      <div className="container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
          <div className="lg:col-span-8 xl:col-span-7 h-full flex flex-col justify-center py-14 md:py-40">
            <h3 className="text-4xl sm:text-5xl lg:text-6xl font-bold !leading-[112%]">{title || "CTA"}</h3>
            {description && <p className="mt-8 text-xl md:text-2xl w-[80%]">{description}</p>}
            {button && (
              <div className="mt-10">
                <ButtonLink {...button} />
              </div>
            )}
          </div>
          {illustration && illustration.data && (
            <div className="lg:col-span-4 xl:col-span-5 h-full flex flex-col justify-end">
              <Image
                src={illustration.data?.attributes?.url || ""}
                width={illustration.data?.attributes?.width || 780}
                height={illustration.data?.attributes?.height || 788}
                alt={illustration.data?.attributes?.alternativeText || illustration.data?.attributes?.name}
                className="w-auto h-auto max-h-[700px] object-contain"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
